import * as React from "react";
import { styled, alpha } from "@mui/material";

import { makeStyles } from "@mui/styles";
import Color from "color";

export const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor:  theme.palette.background.main,
    textAlign: "center",
    height:theme.spacing(30),
    display: "flex",
    flexDirection: "column",
    justifyContent:"center",
    alignItems: "center",

  },
  cardContentsWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent:"center",
    alignItems: "center"
    , padding: theme.spacing(1),
    "& *": {
      margin: theme.spacing(0.5),
    }
  },

  cardHeader: {
    color: theme.palette.text.main,
    fontWeight: "500",
    // fontSize:theme.spacing(3)
  },

  cardText: {
    color: alpha(theme.palette.text.main, 0.7),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize:theme.spacing(1.5)
  },

  percentageChangeAvatarIcon: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
  },

  circularAvatar: {
    padding: theme.spacing(3.1),
    textAlign:"center",
    backgroundColor: alpha(theme.palette.primary.main, 0.25),
    color: theme.palette.primary.main,
    transition: theme.transitions.duration.fancy,

    "&:hover, &:focus": {
      backgroundColor: alpha(theme.palette.primary.main, 1),
      color: theme.palette.text.tertiary,
    },
  },

}));
